import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-serif text-4xl md:text-5xl mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="text-lg text-gray-600 mb-8">
              Last updated: {new Date().toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">1. Introduction</h2>
              <p>
                The Gem Atelier ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and make purchases from our online gemstone boutique.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">2. Information We Collect</h2>
              <h3 className="font-medium text-xl mb-2">Personal Information</h3>
              <p className="mb-4">When you create an account, make a purchase, or contact us, we may collect:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Name and contact details (email address, phone number)</li>
                <li>Billing and shipping addresses</li>
                <li>Payment information (processed securely through our payment provider)</li>
                <li>Order history and preferences</li>
                <li>Communications with our team</li>
              </ul>
              
              <h3 className="font-medium text-xl mb-2">Automatically Collected Information</h3>
              <p>We may automatically collect certain information when you visit our website, including:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Device and browser information</li>
                <li>IP address and location data</li>
                <li>Pages visited and time spent on our site</li>
                <li>Referring website addresses</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">3. How We Use Your Information</h2>
              <p className="mb-4">We use the information we collect to:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Process and fulfil your orders</li>
                <li>Communicate with you about your purchases and enquiries</li>
                <li>Send you updates about new gemstones and collections (with your consent)</li>
                <li>Improve our website and services</li>
                <li>Prevent fraud and ensure security</li>
                <li>Comply with legal obligations</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">4. Information Sharing</h2>
              <p className="mb-4">
                We do not sell, trade, or rent your personal information to third parties. We may share your information with:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Payment processors to complete transactions</li>
                <li>Shipping carriers to deliver your orders</li>
                <li>Service providers who assist our operations</li>
                <li>Legal authorities when required by law</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">5. Data Security</h2>
              <p>
                We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, alteration, disclosure, or destruction. All payment transactions are encrypted using SSL technology and processed through PCI-compliant payment providers.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">6. Your Rights</h2>
              <p className="mb-4">You have the right to:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt out of marketing communications</li>
                <li>Withdraw consent where applicable</li>
              </ul>
              <p>
                To exercise these rights, please contact us through our website messaging system.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">7. Cookies</h2>
              <p>
                We use cookies and similar technologies to enhance your browsing experience, analyse site traffic, and personalise content. You can control cookie settings through your browser preferences.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">8. Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-serif text-2xl mb-4">9. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy or our data practices, please contact us through our website's messaging system or visit our Contact page.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPage;
